export enum PROSPECT_TYPE {
  CANDIDATE = 'CANDIDATE',
  AGENCY = 'AGENCY',
  ONBOARDING = 'ONBOARDING',
  REGISTRATION_COMPLETED = 'REGISTRATION_COMPLETED',
}

export const titleOptions = [
  { label: 'None', value: 'NONE' },
  { label: 'Mr', value: 'MR' },
  { label: 'Miss', value: 'MISS' },
  { label: 'Ms', value: 'MS' },
  { label: 'Mrs', value: 'MRS' },
  { label: 'Dr', value: 'DR' },
];

export const defaultsBusinessTypeOptions = [
  { label: 'Sole Trader', value: 'SOLE_TRADER' },
  { label: 'Company', value: 'COMPANY' },
  { label: 'Partnership', value: 'PARTNERSHIP' },
];

export const PROSPECT_DEFAULT_PAGE_SIZE = 20;
export const PROSPECT_TABLE_SCROLL = { x: 2000, y: 700 };
export const PROSPECT_ONBOARDING_TABLE_SCROLL = { x: 1200, y: 700 };
